import jsonapi from 'jsonapi-parse';
import UserProfile from '@/models/read/User/UserProfile';

export default $axios => () => ({
    async getSchools(query) {
        try {
            let response = await $axios.$get(`/rest/student/schools?q=${query}`);
            return response.data;
        } catch (error) {
            return [];
        }
    },

    async createSchool(name) {
        return $axios.$post(`/rest/student/schools`, {
            name: name,
        });
    },

    async getFieldsOfStudy() {
        try {
            let response = await $axios.$get(`/api/v1/student/fields-of-study`);
            return response.data;
        } catch (error) {
            return [];
        }
    },

    async getEducationalDegree(country) {
        try {
            let response = await $axios.$get(`/rest/student/educational-degrees?country=${country}`);
            return response.data;
        } catch (error) {
            return [];
        }
    },

    async updateUserProfile(userId, data) {
        let response = await $axios.put(`/rest/student/profile/${userId}`, data);
        return response;
    },

    async getUserProfile(userId) {
        try {
            let response = await $axios.get(`/rest/student/profile/${userId}`);
            return new UserProfile(jsonapi.parse(response.data).data);
        } catch (error) {
            return [];
        }
    },
});
